import React from "react";
import { Outlet } from "react-router-dom";
import { MobilePageWrapper } from "./styled";
import usePageTracking  from "../hooks/usePageTracking";

const DispatchLayout = () =>{
  if (process.env.REACT_APP_ENVIRONMENT === "production") {
    usePageTracking();
  }

  return (
    <MobilePageWrapper>
      <Outlet/>
    </MobilePageWrapper>
  )
}

export default DispatchLayout;